import styled from 'styled-components';
import coloricon from '../../styles/coloricon';

const { secondaryColor } = coloricon;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`;

export const ContainerError = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  width: 100%;
  margin: 3px 0px;

  span {
    display: flex;
    align-items: center;
    color: ${secondaryColor};
    font-size: 0.85em;
  }

  svg {
    color: ${secondaryColor};
    margin-right: 5px;
  }
`;
